import { _ } from "vue-underscore";

const tribuneE = {
  tribunePrefix: "E",
  seats: [..._.range(177, 0, -1)],
  rows: [
    {
      name: 5,
      items: [..._.range(141, 178, +1), "empty"]
    },
    {
      name: "stairs",
      items: ["stairs", "stairs", ...Array(35).fill("empty"), "stairs"]
    },
    { name: 4, items: ["empty", "empty", ..._.range(106, 141, +1), "empty"] },
    {
      name: "stairs",
      items: ["stairs", "stairs", ...Array(35).fill("empty"), "stairs"]
    },
    { name: 3, items: ["empty", "empty", ..._.range(71, 106, +1), "empty"] },
    {
      name: "stairs",
      items: ["stairs", "stairs", ...Array(35).fill("empty"), "stairs"]
    },
    { name: 2, items: ["empty", "empty",..._.range(36, 71, +1), "empty"] },
    {
      name: "stairs",
      items: ["stairs", "stairs", ...Array(35).fill("empty"), "stairs"]
    },
    { name: 1, items: ["empty", "empty",..._.range(1, 36, +1), "empty"] }
  ]
};

export default tribuneE;
